import React from 'react';
import Proptypes from 'prop-types';

import './scss/bottomdisclaimer.scss'

const BottomDisclaimer = ({ disclaimerText, closeButtonText, readText, link, onClick }) => (
    <div className='bottom__disclaimer__overlay'>
      <div className="bottom__disclaimer__box">
        <p>{disclaimerText} - <a href={link}>{readText}</a></p>
        <button
          className='btn-primary'
          onClick={onClick}
        >
          {closeButtonText}
        </button>
      </div>
    </div>
  );

BottomDisclaimer.proptypes= {
  disclaimerText: Proptypes.string.isRequired,
  closeButtonText: Proptypes.string.isRequired,
  readText: Proptypes.string.isRequired,
  link: Proptypes.string.isRequired,
  onClick: Proptypes.func.isRequired
};

export default BottomDisclaimer;
